import {NavLink} from "react-router-dom";

export default function SidebarHeader({buttonTrigger, sidebarOpen, setSidebarOpen}) {
    return (
        <div className="flex justify-between mb-9">
            {/* Logo */}
            <NavLink end to="/" className="block">
                <div className="flex">

                    <svg className="logo text-violet-600 dark:text-violet-400" width="121" height="32" viewBox="0 0 662 183" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="m563.401 136.001-26.387-40.234-25.603 40.234h-11.234l28.396-44.674a8.181 8.181 0 0 0-.049-8.854l-24.69-37.913h11.888l22.337 34.095 21.815-34.095h11.234l-24.591 38.527a8.18 8.18 0 0 0 .044 8.872l28.727 44.042h-11.887ZM473.832 136.001v-91.44h10.189V136h-10.189ZM457.587 53.443h-29.898v82.558H417.5V53.443h-30.159V44.56h70.246v8.883ZM377.69 136.001V90.534h-9.963v45.467h9.963ZM320.162 136.001V90.534h-9.964v45.467h9.964Z"
                            fill="currentColor"/>
                        <path fillRule="evenodd" clipRule="evenodd"
                              d="M219.455 136.001v-91.44H272.605c11.95 0 21.637 9.687 21.637 21.636V114.364c0 11.95-9.687 21.637-21.637 21.637h-53.15Zm40.562-82.557h-30.373v73.675h41.783c6.829 0 12.364-5.536 12.364-12.364V65.808c0-6.829-5.535-12.364-12.364-12.364h-11.41ZM586.459 114.364V66.197c0-11.95 9.687-21.637 21.636-21.637H639.609c11.95 0 21.637 9.688 21.637 21.637V114.364c0 11.95-9.687 21.637-21.637 21.637h-31.514c-11.949 0-21.636-9.687-21.636-21.637Zm40.563-60.92h-18.009c-6.828 0-12.364 5.535-12.364 12.364v48.947c0 6.828 5.536 12.364 12.364 12.364h29.42c6.828 0 12.363-5.536 12.363-12.364V65.808c0-6.829-5.535-12.364-12.363-12.364h-11.411ZM377.638 105.941h-67.44V67.428c0-11.95 9.687-21.637 21.637-21.637h24.167c11.949 0 21.636 9.687 21.636 21.637v38.513Zm-57.556-27.925v17.736h47.674V67.606c0-6.828-5.535-12.363-12.363-12.363h-22.948c-6.828 0-12.363 5.535-12.363 12.363v10.411Z"
                              fill="currentColor"/>
                        <g clipPath="url(#a)" fill="currentColor">
                            <rect width="5.526" height="5.526" rx="2.763"
                                  transform="matrix(1 0 0 -1 5.527 177.354)"/>
                            <rect width="5.526" height="5.526" rx="2.763"
                                  transform="matrix(1 0 0 -1 22.105 177.354)"/>
                            <rect width="7" height="7" rx="3.5"
                                  transform="matrix(1 0 0 -1 37.947 178.092)"/>
                            <rect width="8.473" height="8.473" rx="4.237"
                                  transform="matrix(1 0 0 -1 53.79 178.828)"/>
                            <rect width="8.473" height="8.473" rx="4.237"
                                  transform="matrix(1 0 0 -1 70.368 178.828)"/>
                            <rect width="11.421" height="11.421" rx="5.71"
                                  transform="matrix(1 0 0 -1 85.473 180.302)"/>
                            <rect width="11.421" height="11.421" rx="5.71"
                                  transform="matrix(1 0 0 -1 102.051 180.302)"/>
                            <rect width="11.421" height="11.421" rx="5.71"
                                  transform="matrix(1 0 0 -1 118.63 180.302)"/>
                            <rect width="5.526" height="5.526" rx="2.763"
                                  transform="matrix(1 0 0 -1 5.527 160.776)"/>
                            <rect width="5.526" height="5.526" rx="2.763"
                                  transform="matrix(1 0 0 -1 22.105 160.776)"/>
                            <rect width="8.473" height="8.473" rx="4.237"
                                  transform="matrix(1 0 0 -1 37.21 162.25)"/>
                            <rect width="8.473" height="8.473" rx="4.237"
                                  transform="matrix(1 0 0 -1 53.79 162.25)"/>
                            <rect width="8.473" height="8.473" rx="4.237"
                                  transform="matrix(1 0 0 -1 70.368 162.25)"/>
                            <rect width="11.421" height="11.421" rx="5.71"
                                  transform="matrix(1 0 0 -1 85.473 163.724)"/>
                            <rect width="11.421" height="11.421" rx="5.71"
                                  transform="matrix(1 0 0 -1 102.051 163.724)"/>
                            <rect width="11.421" height="11.421" rx="5.71"
                                  transform="matrix(1 0 0 -1 118.63 163.724)"/>
                            <rect width="13.631" height="13.631" rx="6.816"
                                  transform="matrix(1 0 0 -1 134.103 164.829)"/>
                            <rect width="7" height="7" rx="3.5"
                                  transform="matrix(1 0 0 -1 4.79 144.935)"/>
                            <rect width="7" height="7" rx="3.5"
                                  transform="matrix(1 0 0 -1 21.368 144.935)"/>
                            <rect width="7" height="7" rx="3.5"
                                  transform="matrix(1 0 0 -1 37.947 144.935)"/>
                            <rect width="7" height="7" rx="3.5"
                                  transform="matrix(1 0 0 -1 54.525 144.935)"/>
                            <rect width="7" height="7" rx="3.5"
                                  transform="matrix(1 0 0 -1 71.105 144.935)"/>
                            <rect width="8.473" height="8.473" rx="4.237"
                                  transform="matrix(1 0 0 -1 86.946 145.671)"/>
                            <rect width="11.421" height="11.421" rx="5.71"
                                  transform="matrix(1 0 0 -1 102.051 147.145)"/>
                            <rect width="11.421" height="11.421" rx="5.71"
                                  transform="matrix(1 0 0 -1 118.63 147.145)"/>
                            <rect width="13.631" height="13.631" rx="6.816"
                                  transform="matrix(1 0 0 -1 134.103 148.25)"/>
                            <rect width="11.421" height="11.421" rx="5.71"
                                  transform="matrix(1 0 0 -1 151.787 147.145)"/>
                            <rect width="7" height="7" rx="3.5"
                                  transform="matrix(1 0 0 -1 4.79 128.356)"/>
                            <rect width="8.473" height="8.473" rx="4.237"
                                  transform="matrix(1 0 0 -1 20.632 129.093)"/>
                            <rect width="7" height="7" rx="3.5"
                                  transform="matrix(1 0 0 -1 37.947 128.356)"/>
                            <rect width="7" height="7" rx="3.5"
                                  transform="matrix(1 0 0 -1 104.261 128.356)"/>
                            <rect width="11.421" height="11.421" rx="5.71"
                                  transform="matrix(1 0 0 -1 118.63 130.566)"/>
                            <rect width="13.631" height="13.631" rx="6.816"
                                  transform="matrix(1 0 0 -1 134.103 131.672)"/>
                            <rect width="13.631" height="13.631" rx="6.816"
                                  transform="matrix(1 0 0 -1 150.682 131.672)"/>
                            <rect width="8.473" height="8.473" rx="4.237"
                                  transform="matrix(1 0 0 -1 4.054 112.514)"/>
                            <rect width="8.473" height="8.473" rx="4.237"
                                  transform="matrix(1 0 0 -1 20.632 112.514)"/>
                            <rect width="8.473" height="8.473" rx="4.237"
                                  transform="matrix(1 0 0 -1 37.21 112.514)"/>
                            <rect width="8.473" height="8.473" rx="4.237"
                                  transform="matrix(1 0 0 -1 120.104 112.514)"/>
                            <rect width="13.631" height="13.631" rx="6.816"
                                  transform="matrix(1 0 0 -1 134.103 115.093)"/>
                            <rect width="15.105" height="15.105" rx="7.552"
                                  transform="matrix(1 0 0 -1 149.945 115.829)"/>
                            <rect width="11.421" height="11.421" rx="5.71"
                                  transform="matrix(1 0 0 -1 2.58 97.41)"/>
                            <rect width="8.473" height="8.473" rx="4.237"
                                  transform="matrix(1 0 0 -1 20.632 95.936)"/>
                            <rect width="8.473" height="8.473" rx="4.237"
                                  transform="matrix(1 0 0 -1 37.21 95.936)"/>
                            <rect width="8.473" height="8.473" rx="4.237"
                                  transform="matrix(1 0 0 -1 120.104 95.936)"/>
                            <rect width="13.631" height="13.631" rx="6.816"
                                  transform="matrix(1 0 0 -1 134.103 98.515)"/>
                            <rect width="15.105" height="15.105" rx="7.552"
                                  transform="matrix(1 0 0 -1 149.945 99.251)"/>
                            <rect width="13.631" height="13.631" rx="6.816"
                                  transform="matrix(1 0 0 -1 1.475 81.936)"/>
                            <rect width="11.421" height="11.421" rx="5.71"
                                  transform="matrix(1 0 0 -1 19.158 80.831)"/>
                            <rect width="8.473" height="8.473" rx="4.237"
                                  transform="matrix(1 0 0 -1 37.21 79.357)"/>
                            <rect width="8.473" height="8.473" rx="4.237"
                                  transform="matrix(1 0 0 -1 120.104 79.357)"/>
                            <rect width="13.631" height="13.631" rx="6.816"
                                  transform="matrix(1 0 0 -1 134.103 81.936)"/>
                            <rect width="15.105" height="15.105" rx="7.552"
                                  transform="matrix(1 0 0 -1 149.945 82.673)"/>
                            <rect width="13.631" height="13.631" rx="6.816"
                                  transform="matrix(1 0 0 -1 1.475 65.357)"/>
                            <rect width="11.421" height="11.421" rx="5.71"
                                  transform="matrix(1 0 0 -1 19.158 64.252)"/>
                            <rect width="11.421" height="11.421" rx="5.71"
                                  transform="matrix(1 0 0 -1 35.737 64.252)"/>
                            <rect width="7" height="7" rx="3.5"
                                  transform="matrix(1 0 0 -1 104.261 62.042)"/>
                            <rect width="11.421" height="11.421" rx="5.71"
                                  transform="matrix(1 0 0 -1 118.63 64.252)"/>
                            <rect width="13.631" height="13.631" rx="6.816"
                                  transform="matrix(1 0 0 -1 134.103 65.357)"/>
                            <rect width="13.631" height="13.631" rx="6.816"
                                  transform="matrix(1 0 0 -1 150.682 65.357)"/>
                            <rect width="13.631" height="13.631" rx="6.816"
                                  transform="matrix(1 0 0 -1 1.475 48.78)"/>
                            <rect width="13.631" height="13.631" rx="6.816"
                                  transform="matrix(1 0 0 -1 18.053 48.78)"/>
                            <rect width="11.421" height="11.421" rx="5.71"
                                  transform="matrix(1 0 0 -1 35.737 47.674)"/>
                            <rect width="11.421" height="11.421" rx="5.71"
                                  transform="matrix(1 0 0 -1 52.315 47.674)"/>
                            <rect width="11.421" height="11.421" rx="5.71"
                                  transform="matrix(1 0 0 -1 68.894 47.674)"/>
                            <rect width="11.421" height="11.421" rx="5.71"
                                  transform="matrix(1 0 0 -1 85.473 47.674)"/>
                            <rect width="11.421" height="11.421" rx="5.71"
                                  transform="matrix(1 0 0 -1 102.051 47.674)"/>
                            <rect width="11.421" height="11.421" rx="5.71"
                                  transform="matrix(1 0 0 -1 118.63 47.674)"/>
                            <rect width="13.631" height="13.631" rx="6.816"
                                  transform="matrix(1 0 0 -1 134.103 48.78)"/>
                            <rect width="11.421" height="11.421" rx="5.71"
                                  transform="matrix(1 0 0 -1 151.787 47.674)"/>
                            <rect width="15.105" height="15.105" rx="7.552"
                                  transform="matrix(1 0 0 -1 .738 32.937)"/>
                            <rect width="13.631" height="13.631" rx="6.816"
                                  transform="matrix(1 0 0 -1 18.053 32.2)"/>
                            <rect width="13.631" height="13.631" rx="6.816"
                                  transform="matrix(1 0 0 -1 34.632 32.2)"/>
                            <rect width="13.631" height="13.631" rx="6.816"
                                  transform="matrix(1 0 0 -1 51.21 32.2)"/>
                            <rect width="13.631" height="13.631" rx="6.816"
                                  transform="matrix(1 0 0 -1 67.79 32.2)"/>
                            <rect width="13.631" height="13.631" rx="6.816"
                                  transform="matrix(1 0 0 -1 84.367 32.2)"/>
                            <rect width="13.631" height="13.631" rx="6.816"
                                  transform="matrix(1 0 0 -1 100.945 32.2)"/>
                            <rect width="13.631" height="13.631" rx="6.816"
                                  transform="matrix(1 0 0 -1 117.524 32.2)"/>
                            <rect width="13.631" height="13.631" rx="6.816"
                                  transform="matrix(1 0 0 -1 134.103 32.2)"/>
                            <rect width="15.105" height="15.105" rx="7.552"
                                  transform="matrix(1 0 0 -1 .738 16.358)"/>
                            <rect width="15.105" height="15.105" rx="7.552"
                                  transform="matrix(1 0 0 -1 17.316 16.358)"/>
                            <rect width="13.631" height="13.631" rx="6.816"
                                  transform="matrix(1 0 0 -1 34.632 15.622)"/>
                            <rect width="13.631" height="13.631" rx="6.816"
                                  transform="matrix(1 0 0 -1 51.21 15.622)"/>
                            <rect width="13.631" height="13.631" rx="6.816"
                                  transform="matrix(1 0 0 -1 67.79 15.622)"/>
                            <rect width="13.631" height="13.631" rx="6.816"
                                  transform="matrix(1 0 0 -1 84.367 15.622)"/>
                            <rect width="11.421" height="11.421" rx="5.71"
                                  transform="matrix(1 0 0 -1 102.051 14.517)"/>
                            <rect width="11.421" height="11.421" rx="5.71"
                                  transform="matrix(1 0 0 -1 118.63 14.517)"/>
                        </g>
                        <defs>
                            <clipPath id="a">
                                <path fill="currentColor" transform="matrix(1 0 0 -1 0 182.88)"
                                      d="M0 0h167.259v182.364H0z"/>
                            </clipPath>
                        </defs>
                    </svg>
                </div>
            </NavLink>

            {/* Close button */}
            <button
                ref={buttonTrigger}
                className="lg:hidden text-slate-500 hover:text-slate-400"
                onClick={(e) => {
                    e.stopPropagation();
                    setSidebarOpen(!sidebarOpen);
                }}
                aria-controls="sidebar"
                aria-expanded={sidebarOpen}
            >
                <span className="sr-only">Close sidebar</span>
                <svg className="cbm9w" width="16" height="16" viewBox="0 0 16 16">
                    <path
                        fill="currentColor"
                        d="M7.95 6.536l4.242-4.243a1 1 0 111.415 1.414L9.364 7.95l4.243 4.242a1 1 0 11-1.415 1.415L7.95 9.364l-4.243 4.243a1 1 0 01-1.414-1.415L6.536 7.95 2.293 3.707a1 1 0 011.414-1.414L7.95 6.536z"></path>
                </svg>
            </button>
        </div>
    );

}